import { thenable } from '../../utils/promise/thenable';
export function largeSegmentMatcherContext(largeSegmentName, storage) {
    return function largeSegmentMatcher(key) {
        var isInLargeSegment = storage.largeSegments ? storage.largeSegments.isInSegment(largeSegmentName, key) : false;
        if (thenable(isInLargeSegment)) {
            isInLargeSegment.then(function (result) {
                return result;
            });
        }
        return isInLargeSegment;
    };
}
